<template>
    <b-card class="mt-4" :header-html="
        `<h4><i class='glyphicon glyphicon-map-marker'></i> Endereço</h4>`
    "> 
        <b-form-row>
            <b-col cols="12" v-if="cepInvalido">
                <b-alert variant="warning" show>CEP inválido</b-alert>
            </b-col>
            
            <b-form-group
                label-for="label-sr-only"
                class="col-md-3 required"
                label="CEP"
            >
                <b-form-input
                    v-model="data.Loja.cep"
                    name="data.Loja.cep"
                    max="10" v-validate="'required'"
                    :class="[{ error: errors.first('data.Loja.cep') }]"
                    autocomplete="off"
                    v-mascara-cep
                    @change="buscaCep($event)"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                label-for="label-sr-only"
                class="col-md-6 required"
                label="Logradouro"
            >
                <b-form-input
                    v-model="data.Loja.logradouro"
                    name="data.Loja.logradouro"
                    max="60"
                    v-validate="'required'"
                    autocomplete="off"
                    :class="[{ error: errors.first('data.Loja.logradouro') }]"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                label-for="label-sr-only"
                class="col-md-3 required"
                label="Número"
            >
                <b-form-input
                    max="10"
                    ref="inputNumero"
                    v-model="data.Loja.numero"
                    name="data.Loja.numero"
                    autocomplete="off"
                    v-validate="'required'"
                    :class="[{ error: errors.first('data.Loja.numero') }]"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                label-for="label-sr-only"
                class="col-md-3"
                label="Complemento"
            >
                <b-form-input
                    v-model="data.Loja.complemento"
                    name="data.Loja.complemento"
                    max="20"
                    :class="[
                        {
                            error: errors.first(
                                'data.Loja.complemento'
                            ),
                        },
                    ]"
                    autocomplete="off"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                label-for="label-sr-only"
                class="col-md-3 required"
                label="Bairro"
            >
                <b-form-input
                    v-model="data.Loja.bairro"
                    name="data.Loja.bairro"
                    max="45"
                    v-validate="'required'"
                    :class="[{ error: errors.first('data.Loja.bairro') }]"
                    autocomplete="off"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                label-for="estado"
                class="col-md-3 required"
                label="Estado"
            >
                <b-form-select
                    id="estado"
                    v-model="data.Loja.estado"
                    name="data.Loja.estado"
                    v-validate="'required'"
                    @change="buscaCidades"
                    :class="[{ error: errors.first('data.Loja.estado') }]"
                >
                    <option value="">Selecione</option>
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso Do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio De Janeiro</option>
                    <option value="RN">Rio Grande Do Norte</option>
                    <option value="RS">Rio Grande Do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                </b-form-select>
            </b-form-group>
            <b-form-group
                label-for="label-sr-only"
                class="col-md-3 required"
                label="Cidade"
            >
                <b-form-select
                    name="cidade"
                    v-validate="'required'"
                    v-model="data.Loja.cidade_id"
                    :disabled="!cidades.length"
                    :class="[{ error: errors.first('cidade') }]"
                >
                    <option value="">Selecione</option>
                    <option 
                        v-for="(c, index) in cidades" 
                        :key="index" 
                        :value="c.id"
                    >
                        {{ c.cidade }}
                    </option>
                </b-form-select>
            </b-form-group>
        </b-form-row>
    </b-card>
</template>
<script>
import '@/shared/common/directives/mascaras/data'
export default {
    inject: ['$validator'],
    props: {
        data: { type: Object }
    },
    data() {
        return {
            cep: '', 
            cidades: [],
            cepInvalido: false
        }
    },
    watch: {
        cepInvalido () {
            if (this.cepInvalido) {
                this.data.Loja.cidade_id = ''
            }
        }
    },
    methods: {      
        async selecionaCidade(cidade) {
            if (cidade) {
                this.data.Loja.timezone = cidade.timezone
                this.data.Loja.utc_verao = cidade.utc_verao
                this.data.Loja.utc_normal = cidade.utc_normal
                this.data.Loja.codigo_estado = cidade.codigo_estado
                this.data.Loja.nome_cidade = cidade.nome ? cidade.nome : cidade.nome_cidade
                this.data.Loja.codigo_cidade = cidade.codigo  ?  cidade.codigo :  cidade.codigo_cidade
                this.data.Loja.codigo_siafi = cidade.codigo_siafi  ? cidade.codigo_siafi : cidade.codigo_siafi_cidade
                if (cidade.estado) {
                    await this.buscaCidades (cidade.estado)
                }
                // É preciso esperar carregar as cidades
                this.data.Loja.cidade_id = String(cidade.id ? cidade.id : cidade.cidade_id)
                this.$forceUpdate()
            }
        },
        async buscaCidades(estado) {
            // Para corrigir bug
            if (!estado) {
                this.cidades = []
                this.data.Loja.cidade_id = ''
                return
            }
            let retorno = await this.$api.get(
                this.$urlBase 
                + '/cidades/buscaCidades', { 
                    'estado': estado, 'limite': 1000 
                }
            )
            if (retorno.status == 'success') {
                this.cidades = retorno.data
            }
        },
        async buscaCep (cepValue) {
            const cep = String(cepValue);
            if (cep.length == 9 && cep != this.cep) {
                const retorno = await this.$api.get(this.$urlBase + '/cidades/busca_cep/' + cep)
                this.cepInvalido = retorno.status != 'success'
                if (retorno && retorno.status == 'success') {
                    this.data.Loja.logradouro = retorno.data.logradouro
                    this.data.Loja.bairro = retorno.data.bairro
                    this.data.Loja.estado = retorno.data.estado
                    await this.selecionaCidade(retorno.data)
                    this.$refs.inputNumero.focus()
                }
            }
        }
    }
}
</script>
